import type {SurahData} from './qaidaCourse'

// Arabic Lab → Read a sūrah: the sūrah list, a sūrah's words and its recitation audio, through Dawwin's API (which asks
// Dawwin Research, which asks the Quran Foundation). Answers are kept for the session; a failed request is not.
const API='https://api.dawwin.al-ilm.net/research/quran'
export type SurahInfo={id:number;name:string;arabic:string;english:string;verses:number;place:string}
const kept=new Map<string,Promise<unknown>>()
function call<T>(path:string):Promise<T>{
 let pending=kept.get(path) as Promise<T>|undefined
 if(!pending){
  pending=fetch(API+path,{credentials:'include',headers:{Accept:'application/json'}}).then(async r=>{if(!r.ok)throw new Error('http_'+r.status);return await r.json() as T})
  pending.catch(()=>kept.delete(path))
  kept.set(path,pending)
 }
 return pending
}
export const listSurahs=()=>call<{surahs:SurahInfo[]}>('/surahs')
export const getSurah=(n:number)=>call<SurahData>(`/surahs/${n}`)
export const getSurahAudio=(n:number,recitation:number)=>call<{files:Record<string,string>}>(`/surahs/${n}/audio?recitation=${recitation}`)
